export interface CmsApplianceDetailsModelSerialConfirmation {
  title: string;
  body: string;
}
